import { render, staticRenderFns } from "./buffetOrder.vue?vue&type=template&id=63780e16&scoped=true&"
import script from "./buffetOrder.vue?vue&type=script&lang=js&"
export * from "./buffetOrder.vue?vue&type=script&lang=js&"
import style0 from "./buffetOrder.vue?vue&type=style&index=0&id=63780e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63780e16",
  null
  
)

export default component.exports